import { ModelBase } from '@framework/models/base/base.model';
import { UserContextModel } from '../../auth-models';

export class LoginTwitterOutputApiModel extends ModelBase {
    public userContext: UserContextModel;
    constructor(init?: Partial<LoginTwitterOutputApiModel>){
        super(init);
        Object.assign(this, init);
    }
}